import { inject } from '@angular/core';
import { of } from 'rxjs';
import { CanActivateFn, Router } from '@angular/router';
import {
  LocalStorageAsyncService,
  LocalStorageKeys,
} from '@app/shared/services/local-storage-async.service';
import { ConfigService } from '@app/shared/services/config.service';

export const over18Guard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const configService = inject(ConfigService);

  if (state.url === '/info/terms' || state.url === '/info/privacy-policy') {
    return of(true);
  }
  if (
    LocalStorageAsyncService.getStorageValueWithTimestamp(
      LocalStorageKeys.over18ApprovalKey,
      +configService.config.over18AcceptDuration
    )
  ) {
    return of(true);
  }

  LocalStorageAsyncService.setStorageValue(
    LocalStorageKeys.redirectUrlAfterOver18,
    state.url
  );
  router.navigate(['/check-18']);
  return of(false);
};
